module.exports = __webpack_public_path__ + "img/emoji-wink.11b170dc.svg";